import React, { useState, useEffect, useRef } from "react";
import HttpClient from "../../utils/HttpClient";
import { useLanguage } from "../../Providers/LanguageContext";
import Select from 'react-select';
import './MilestonePopUp.css';
import toast from "react-hot-toast";
import { FaPlus, FaMinus } from 'react-icons/fa';

function PhasePopUp({ closeModal }) {
    const { language } = useLanguage();
    const [formData, setFormData] = useState({
        projectId: "",
    });
    const [phases, setPhases] = useState([{
        name: "",
        amount: 0,
        milestones: [], // Changed from taskIds to milestones to match API
    }]);
    const [projects, setProjects] = useState([]);
    const [milestoneOptions, setMilestoneOptions] = useState([]); // Changed from taskOptions
    const [selectedProject, setSelectedProject] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [allMilestones, setAllMilestones] = useState([]); // Changed from taskAllData
    const [isUpdate, setIsUpdate] = useState(false);
    useEffect(() => {
        fetchProjects();
    }, []);

    useEffect(() => {
        if (allMilestones?.length) {
            const options = allMilestones.map(milestone => ({
                value: milestone._id,
                label: milestone.name || milestone.milestoneName // Adjust based on your actual data structure
            }));
            setMilestoneOptions(options);
        } else {
            setMilestoneOptions([]);
        }
    }, [allMilestones]);

    const fetchProjects = async () => {
        const res = await HttpClient.requestData("view-all-project", "GET", {});
        if (res && res.status) {
            setProjects(res.data);
        } else {
            setProjects([]);
        }
    };

    const fetchMilestones = async () => {
        // Adjust this endpoint to fetch all available milestones
        const res = await HttpClient.requestData("view-all-milestones", "GET", {});
        if (res && res.status) {
            setAllMilestones(res.data);
        } else {
            setAllMilestones([]);
        }
    };

    useEffect(() => {
        if (selectedProject) {
            fetchMilestones();
        }
    }, [selectedProject]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "projectId") {
            const selected = projects.find(project => project?._id === value);
            setSelectedProject(selected || null);
        }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePhaseChange = (index, e) => {
        const { name, value } = e.target;
        const updatedPhases = [...phases];
        updatedPhases[index] = {
            ...updatedPhases[index],
            [name]: name === "amount" ? Number(value) : value
        };
        setPhases(updatedPhases);
    };

    const handleMilestoneSelectChange = (index, selectedOptions) => {
        const updatedPhases = [...phases];
        updatedPhases[index].milestones = selectedOptions ? selectedOptions.map(option => ({
            _id: option.value,
            name: option.label
        })) : [];
        setPhases(updatedPhases);
    };

    const addPhase = () => {
        setPhases([...phases, {
            name: "",
            amount: 0,
            milestones: [],
        }]);
    };

    const removePhase = (index) => {
        if (phases.length > 1) {
            const updatedPhases = [...phases];
            updatedPhases.splice(index, 1);
            setPhases(updatedPhases);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            let updatedPhase = [];
            if (isUpdate) {
                updatedPhase = phases
                    .filter(phase => !phase.hasOwnProperty('existing')) // Filter phases with existing field
                    .map(phase => ({
                        name: phase.name,
                        amount: phase.amount,
                        // milestones: phase.milestones
                        milestones: [],
                    }));
            } else {
                updatedPhase = phases.map(phase => ({
                    name: phase.name,
                    amount: phase.amount,
                    milestones: phase.milestones
                }));
            }
            const payload = {
                projectId: formData.projectId,
                // phases: phases.map(phase => ({
                //     name: phase.name,
                //     amount: phase.amount,
                //     milestones: phase.milestones // Already an array of milestone IDs
                // })),
                phases: updatedPhase,
            };
            // console.log('final payload: ', payload);

            if (!payload?.phases?.length) {
                return toast.success('Phase add/edited successfully');
            }
            const res = await HttpClient.requestData("phases/addUpdate", "POST", payload);
            if (res?.message === "Phases added successfully.") {
                toast.success(res?.message || "Phases updated successfully");
                setTimeout(() => {
                    closeModal();
                }, 1000);
            } else {
                toast.error(res?.message || 'Something went wrong!!!');
            }
        } catch (error) {
            console.error("Error updating phases:", error);
            toast.error(error?.error ? error?.error : error?.message);
        } finally {
            setIsLoading(false);
            setIsUpdate(false);
        }
    };

    const getExistingPhases = async projectId => {
        try {
            const res = await HttpClient.requestData(`phases/${projectId}`, 'GET');
            if (res && res.data) {
                // Store all milestones from all phases for reference
                const allPhaseMilestones = res.data.flatMap(phase =>
                    phase.milestones.map(m => ({
                        _id: m._id,
                        name: m.milestoneName,
                        phaseId: phase._id // Track which phase this milestone belongs to
                    }))
                );
                setPhases(res.data.map(phase => ({
                    _id: phase._id, // Store phase ID
                    existing: true,
                    name: phase.name,
                    amount: phase.amount,
                    milestones: phase.milestones.map(m => ({
                        _id: m._id,
                        name: m.milestoneName
                    }))
                })));
                setIsUpdate(true);

                // Update milestone options with all milestones, but mark which phase they belong to
                setMilestoneOptions(allPhaseMilestones.map(m => ({
                    value: m._id,
                    label: m.name,
                    phaseId: m.phaseId // Track phase association
                })));
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to load existing phases');
            setPhases([{
                name: "",
                amount: 0,
                milestones: [],
            }]);
            setIsUpdate(false);

        }
    };


    useEffect(() => {
        if (formData?.projectId) {
            getExistingPhases(formData.projectId);
        }
    }, [formData?.projectId]);

    // console.log('phases: ', phases);
    const modalRef=useRef();

    useEffect(()=>{
      const  OustideClickClose =(e)=>{
          if(modalRef.current && !modalRef.current.contains(e.target)){
            closeModal(false)
          }
      }
      document.addEventListener('mousedown',OustideClickClose)
    },[])
    return (
        <div className="modal-overlay">
            <div ref={modalRef} className="modal-content">
                <div className="modal-header">
                    <h3>{language.Phase}</h3>
                    <button onClick={() => closeModal(false)} className="close-btn">×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>{language.Select_Project}</label>
                        <select
                            name="projectId"
                            value={formData.projectId}
                            onChange={handleChange}
                            required
                        >
                            <option value="">{language.select_project}</option>
                            {projects.map(project => (
                                <option key={project._id} value={project._id}>
                                    {project.projectName}
                                </option>
                            ))}
                        </select>
                    </div>

                    {phases.map((phase, index) => (
                        <div key={index} className="milestone-group">
                            <div className="milestone-header">
                                <h4>{language.Phase} {index + 1}</h4>
                                {phases.length > 1 && (
                                    <button
                                        type="button"
                                        onClick={() => removePhase(index)}
                                        className="remove-milestone-btn"
                                    >
                                        <FaMinus />
                                    </button>
                                )}
                            </div>

                            <div className="form-group">
                                <label>{language.Phase_Name}</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={phase.name}
                                    onChange={(e) => handlePhaseChange(index, e)}
                                    placeholder={language.Phase_Name}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>{language.Amount}</label>
                                <input
                                    type="number"
                                    name="amount"
                                    value={phase.amount}
                                    onChange={(e) => handlePhaseChange(index, e)}
                                    placeholder={language.Amount}
                                    required
                                    disabled={phase?.existing ? true : false}
                                    min="0"  // This prevents negative numbers
                                />
                            </div>

                            <div className="form-group">
                                <label>{language.Milestone}</label>
                                <Select
                                    isMulti
                                    name="milestones"
                                    options={
                                        phase.existing
                                            ? milestoneOptions.filter(opt => opt.phaseId === phase._id)
                                            : []
                                    }
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={(selected) => handleMilestoneSelectChange(index, selected)}
                                    placeholder={language.Select_Milestones}
                                    value={milestoneOptions.filter(option =>
                                        phase.milestones.some(m => m._id === option.value)
                                    )}
                                // isDisabled={phase.existing} // Disable for existing phases if needed
                                />
                            </div>
                        </div>
                    ))}
                    <div className="add-milestone-btn-container">
                        <button
                            type="button"
                            onClick={addPhase}
                            className="add-milestone-btn"
                        >
                            <FaPlus /> Add Another Phase
                        </button>
                    </div>


                    <div className="modal-footer">
                        <button type="button" onClick={() => closeModal(false)} className="cancel-btn">
                            {language.cancel}
                        </button>
                        <button type="submit" className="submit-btn" disabled={isLoading}>
                            {isLoading ? language.saving : language.Save}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default PhasePopUp;